import React, { FC } from 'react';
import classNames from 'classnames';
import type { GroundSet, PieceType } from '@whitesharx/starfall-frontend-chessground';
import { FiguresBar, Figures, PlayerColor } from '@whitesharx/starfall-frontend-core';
import { Avatar, Timer, Flag, TimeFormats } from '@whitesharx/starfall-frontend-ui-kit';

import {
  containerStyles,
  timerContainerStyles,
  infoBarStyles,
  playerInfoStyles,
  playerBarFlexStyles,
  infoBarFlexStyles,
  containerAlignStyles,
  playerInfoAlignStyles,
  nameStyles,
  avatarContainerStyles,
  flagContainerStyles,
  emptyFiguresStyles,
} from './styles.css';

type PlayerBarProps = {
  className?: string;
  name?: string;
  country?: string;
  setName?: GroundSet;
  avatarSrc?: string;
  color?: PlayerColor;
  figures?: Figures;
  figuresSetName?: GroundSet;
  leftTime?: number | null;
  isPlayer?: boolean;
  timeFormat?: TimeFormats;
};

const PlayerBar: FC<PlayerBarProps> = ({
  className,
  name,
  country,
  avatarSrc,
  setName,
  color,
  leftTime,
  figures,
  figuresSetName,
  timeFormat,
  isPlayer,
}) => {
  const downedFiguresCount = Object.keys(figures || {}).reduce(
    (acc, next) => acc + (figures ? figures[next as PieceType] : 0),
    0
  );

  return (
    <div className={classNames(containerStyles, className, { [containerAlignStyles]: isPlayer })}>
      <div className={playerBarFlexStyles[isPlayer ? 'reverse' : 'default']}>
        <div className={avatarContainerStyles}>
          <Avatar src={avatarSrc} size={'100%'} frame={setName} />
        </div>
        <div className={classNames(infoBarStyles, infoBarFlexStyles[isPlayer ? 'reverse' : 'default'])}>
          <div className={classNames(playerInfoStyles, { [playerInfoAlignStyles]: isPlayer })}>
            <div className={nameStyles}>{name}</div>
            {country && (
              <div className={flagContainerStyles}>
                <Flag country={country} size={21} />
              </div>
            )}
          </div>
          {downedFiguresCount > 0 && figures && color ? (
            <FiguresBar figures={figures} color={color} reverse={isPlayer} setName={figuresSetName} />
          ) : (
            <div className={emptyFiguresStyles} />
          )}
        </div>
      </div>
      {typeof leftTime === 'number' && timeFormat && (
        <div className={timerContainerStyles}>
          <Timer leftMilliseconds={leftTime} format={timeFormat} pause={true} />
        </div>
      )}
    </div>
  );
};

export default PlayerBar;
